var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutoEnrol = function SvgAutoEnrol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.505L9 4.5C8.725 4.5 8.5 4.725 8.5 5V9.5C8.5 9.775 8.725 10 9 10H11.5C11.775 10 12 9.775 12 9.5V5C12 4.725 11.775 4.505 11.5 4.505ZM11.5 9H9V5.5H11.5V9ZM10 0H1C0.445 0 0 0.445 0 1V7C0 7.55 0.445 8 1 8H4.5V9H3.5V10H7.5V9H6.5V8H7.5V7H1V1H10V3.5H11V1C11 0.445 10.55 0 10 0ZM5.985 3.5L5.5 2L5.015 3.5H3.5L4.735 4.38L4.265 5.835L5.5 4.935L6.735 5.835L6.265 4.38L7.5 3.5H5.985Z",
    fill: "#156147"
  })));
};
export default SvgAutoEnrol;